export function GetSubscriptionTier(subscriptionIndex) {
  switch (subscriptionIndex) {
    case 0:
      return "Free";
    case 1:
      return "Basic";
    case 2:
      return "Plus";
    case 3:
      return "Pro";
    default:
      return "Free";
  }
}

export function GetSubscriptionPrice(subscriptionIndex) {
  switch (subscriptionIndex) {
    case 0:
      return "$0";
    case 1:
      return "$4.99";
    case 2:
      return "$9.99";
    case 3:
      return "$14.99";
    default:
      return "Free";
  }
}
